import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid2,
  IconButton,
  InputLabel,
  keyframes,
  Pagination,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useGetClientCommissionListMutation,
  useGetClientCommissionListQuery,
  useGetClientCommissionMutation,
  useGetClientContactByIdMutation,
  useRecruiterClientAndPositionMutation,
  useSaveClientCommissionMutation,
  useUpdateClientCommissionStatusMutation,
  useViewClientByIdMutation,
} from "../../redux/clients/clients.api";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import MUIButton from "../../reusable_components/components/MUIButton";
import "./viewClients.css";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useSelector } from "react-redux";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import AddIcCallOutlinedIcon from "@mui/icons-material/AddIcCallOutlined";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Dropdown from "../../reusable_components/components/Dropdown";
import { motion, AnimatePresence } from "framer-motion";
import { CiEdit } from "react-icons/ci";
import { useGetPositionLevelDropDownQuery } from "../../redux/Signup/signup.api";


const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const SimpleCommissionLoader = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 240, // Adjust this value to match your drawer width
        width: 'calc(100vw - 240px)', // Subtract drawer width
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* Orbiting Dots Loader */}
        <Box sx={{
          position: 'relative',
          width: 60,
          height: 60,
          animation: `${rotate} 1.5s linear infinite`
        }}>
          {[...Array(7)].map((_, index) => (
            <Box
              key={index}
              sx={{
                position: 'absolute',
                width: 6,
                height: 6,
                backgroundColor: '#7F56D9',
                borderRadius: '50%',
                top: '50%',
                left: '50%',
                transform: `
                  translate(-50%, -50%) 
                  rotate(${index * (360 / 7)}deg) 
                  translate(25px) 
                  rotate(-${index * (360 / 7)}deg)
                `,
                boxShadow: '0 0 6px rgba(127, 86, 217, 0.8)',
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const ViewClients = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const { Profile } = useSelector((state) => state?.common);
  const userRole = Profile?.profile?.role;
  const { Snackbar } = useContext(SnackbarContext);

  const [viewClient, { data: getClientDetails }] = useViewClientByIdMutation();
  const [commissionList, { data: companyCommissionList }] = useGetClientCommissionListMutation()
  const [getClientContactById] = useGetClientContactByIdMutation();
  const [getJobDetails] = useRecruiterClientAndPositionMutation();
  const [saveCommission] = useSaveClientCommissionMutation()
  const [getCommissionById] = useGetClientCommissionMutation()
  const [updateCommissionStatus] = useUpdateClientCommissionStatusMutation()
  const { data: positionLevelDropDown } = useGetPositionLevelDropDownQuery();
  const [isCost, setIsCost] = useState(false)


  const schema = Yup.object().shape({
    rewardType: Yup.string().required("Reward Type is required"),
    rewardsRs: isCost
      ? Yup.number()
        .typeError("Commission (Rs) must be a number")
        .required("Commission (Rs) is required")
        .min(1, "Value must be greater than 0")
      : Yup.mixed().nullable(),
    rewardsPercent: !isCost
      ? Yup.number()
        .typeError("Commission (%) must be a number")
        .required("Commission (%) is required")
        .min(1, "Value must be greater than 0")
        .max(100, "Percentage cannot exceed 100")
      : Yup.mixed().nullable(),
    positionLevel: Yup.string().required("Position Level is required"),
  });

  const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      rewardType: "",
      rewardsRs: "",
      rewardsPercent: "",
      positionLevel: ''
    },
  });

  // ✅ Handle Submit
  const handleFormSubmit = (data) => {
    // onSubmit(data);
  };


  const {
    clientName,
    clientId,
    isReferrals,
    isReferralClient,
    clientCreatedBy,
    createdDate,
    clientStatus,
    tabValue,
  } = location.state || "";
  // const { mappedclientName, mappedclientId, mappedisReferrals, mappedisReferralClient, mappedclientCreatedBy, mappedcreatedDate, mappedclientStatus } = location.state || ''

  const editScreen = clientId;

  const [value, setValues] = useState(tabValue || "1");
  const [jobDetails, setJobDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [commissionId, setcommissionId] = useState()

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChange = (event, newValue) => {
    setValues(newValue);
  };

  useEffect(() => {
    try {
      const payload = {
        clientId: editScreen,
      };
      viewClient(payload);
    } catch (err) {
      Snackbar("Network error", "error");
    }

    getClientDatas();
  }, [editScreen, viewClient]);

  const getCommissionList = () => {
    setShowTableLoader(true)
    try {
      const payload = {
        clientId: editScreen,
      };
      commissionList(payload);
      setTimeout(() => {
        setShowTableLoader(false);
      }, 2000);
    } catch (err) {
      Snackbar("Network error", "error");
      setShowTableLoader(false)

    }
  }

  useEffect(() => {
    if (value === "3") {
      getCommissionList()
    }
  }, [value])

  const [clientContactTableDatas, setClientContactTableDatas] = useState([]);

  const getClientDatas = async () => {
    try {
      const payload = {
        clientId: editScreen,
      };

      const response = await getClientContactById(payload).unwrap();
      setClientContactTableDatas(response?.response);
    } catch (err) {
      Snackbar("Network Error", "error");
    }
  };

  const getJobDetailsList = async () => {
    try {
      const payload = {
        clientId: editScreen,
        page: page - 1,
        size: rowsPerPage,
      };
      setShowTableLoader(true);
      const response = await getJobDetails(payload).unwrap();
      setShowTableLoader(false);
      setJobDetails(response?.response?.data);
      setTotalDataCount(response?.response?.totalItems);
    } catch (err) {
      Snackbar("Network Error", "error");
    }
  };

  useEffect(() => {
    if (value === "2") {
      getJobDetailsList();
    }
  }, [value, page]);

  const handleClientEdit = () => {
    if (isReferrals === true) {
      navigate(`/referrals/client-edit/${editScreen}`, {
        state: {
          isReferrals: isReferrals,
          isReferralClient: isReferralClient,
        },
      });
    } else {
      navigate(`/client-edit/${editScreen}`, {
        state: {
          isReferrals: isReferrals,
          isReferralClient: isReferralClient,
          clientById: true,
          clientId: clientId,
          clientTitle: clientName,
        },
      });
    }
  };

  const handleNavigateBack = () => {
    // if (isReferrals === true) {
    //     navigate("/referrals")
    // } else {
    //     navigate('/client')
    // }
    navigate(-1);
  };

  const [open, setOpen] = useState(false)

  const handleOpenAddCommission = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
    reset({
      rewardType: "",
      rewardsRs: "",
      rewardsPercent: "",
      positionLevel: ""
    });
    setcommissionId('')
  }

  const commissionType = watch("rewardType")

  useEffect(() => {
    if (commissionType === 1) {
      setIsCost(true)
      reset(prev => ({ ...prev, rewardsPercent: "" }))
    } else {
      setIsCost(false)
      reset(prev => ({ ...prev, rewardsRs: "" }))
    }
  }, [commissionType])

  const rewardTypes = [
    {
      id: 1,
      label: "Fixed Amount"
    },
    {
      id: 2,
      label: "Fixed Percentage"
    }
  ]

  const [status, setStatus] = useState()

  const handleOpenCommissionEdit = async (item) => {
    try {
      const payload = {
        clientCommissionId: item?.id
      }
      const response = await getCommissionById(payload).unwrap()
      if (response?.status === 200) {
        setValue("rewardType", response?.response?.data?.companyCommissionType === "FC" ? 1 : 2)
        setValue("rewardsPercent", response?.response?.data?.companyCommissionPercentage)
        setValue("rewardsRs", response?.response?.data?.companyCommissionAmount)
        setValue('positionLevel', response?.response?.data?.jobPositionLevelId)
        setOpen(true)
        setcommissionId(item?.id)
        setStatus(item?.status)
      }
    } catch (error) {
      Snackbar('Network error', 'error')
    }
  }

  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const saveCompanyCommission = async (data) => {
    setIsButtonLoading(true);

    try {
      const payload = {
        ...(commissionId && { id: commissionId }),
        clientId: editScreen,
        companyCommissionType: +data?.rewardType === 1 ? "FC" : "FP",
        companyCommissionPercentage: data?.rewardsPercent || null,
        companyCommissionAmount: data?.rewardsRs || null,
        status: !commissionId ? "Active" : status,
        jobPositionLevelId: +data?.positionLevel || null
      }

      const response = await saveCommission(payload).unwrap()
      if (response?.response?.status === 'success') {
        Snackbar(response?.response?.message, 'success')
        getCommissionList()
        setOpen(false)
        onClose()
      } else if (response?.response?.status === 'error') {
        Snackbar(response?.response?.message, 'error')
      }
    } catch (error) {
      Snackbar(commissionId ? "Network error while update" : "Network error", "error")
      console.error("Error occurred while saving");
    } finally {
      setIsButtonLoading(false);
    }
  }

  const [showUpdateTimeLoader, setShowUpdateTimeLoadder] = useState(false)

  const handleToggleStatus = async (item) => {
    setShowUpdateTimeLoadder(true)
    try {
      const payload = {
        id: item?.id,
        status: item?.status !== "Active" ? "Active" : "Inactive",
      }
      const response = await updateCommissionStatus(payload).unwrap()
      if (response?.response?.status === "success") {
        Snackbar(response?.response?.message, "success")
        getCommissionList()
      } else if (response?.response?.status === "error") {
        Snackbar(response?.response?.message, "error")
      }
      setShowUpdateTimeLoadder(false)

    } catch (err) {
      Snackbar("Network error", 'error')
      setShowUpdateTimeLoadder(false)
    }
  }

  return (
    <Box className="container">
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
          marginBottom: "20px",
        }}
        onClick={handleNavigateBack}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>
      {getClientDetails?.response?.data?.map((item) => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <Box>
            <Typography className="title" sx={{}}>
              {clientName}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              flexWrap: "wrap",
              alignItems: "flex-end",
            }}
          >
            {
              value === "3" && (
                <Box>
                  <MUIButton
                    title="Add Commission"
                    startIcon={<AddIcon />}
                    variant="contained"
                    onClick={handleOpenAddCommission}
                  >
                    Add Commission
                  </MUIButton>
                </Box>
              )
            }
            {/* <MUICancelButton title='Share' sx={{ cursor: userRole === "recruiter" ? "not-allowed" : "pointer" }} startIcon={<ShareOutlinedIcon sx={{ fontSize: '15px !important' }} />} /> */}
            {
              value !== "3" && (
                <Tooltip
                  title={
                    userRole === "recruiter"
                      ? item?.clientCreatedBy === "You" &&
                        clientStatus !== "Rejected"
                        ? ""
                        : "You can't edit the client details"
                      : ""
                  }
                >
                  <MUIButton
                    title="Edit"
                    className="edit-button"
                    sx={{
                      cursor:
                        userRole === "recruiter"
                          ? item?.clientCreatedBy === "You" &&
                            clientStatus !== "Rejected"
                            ? "pointer"
                            : "not-allowed"
                          : "pointer",
                    }}
                    onClick={
                      userRole === "recruiter"
                        ? item?.clientCreatedBy === "You" &&
                          clientStatus !== "Rejected"
                          ? handleClientEdit
                          : null
                        : handleClientEdit
                    }
                  />
                </Tooltip>
              )
            }
          </Box>
        </Box>
      ))}

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="Overview and Candidates tabs"
            textColor="primary"
            indicatorColor="secondary"
          >
            <Tab
              label="Overview"
              value="1"
              className="tabs"
              sx={{
                textTransform: "none",
                fontWeight: value === "1" ? "bold" : "normal",
                transition: "all 0.3s ease",
              }}
            />

            <Tab
              label="Job Details"
              value="2"
              className="tabs"
              sx={{
                textTransform: "none",
                fontWeight: value === "2" ? "bold" : "normal",
                transition: "all 0.3s ease",
              }}
            />
            {userRole === "admin" && (
              <Tab
                label="Commission Details"
                value="3"
                className="tabs"
                sx={{
                  textTransform: "none",
                  fontWeight: value === "3" ? "bold" : "normal",
                  transition: "all 0.3s ease",
                }}
              />
            )
            }
          </TabList>
        </Box>

        {/* tabs  */}
        <TabPanel value="1" sx={{ display: "flex", padding: 0.5 }}>
          {/* main box */}
          <Box
            sx={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              "@media (max-width: 900px)": {
                flexDirection: "column",
              },
            }}
          >
            <Box
              sx={{
                width: "100%",
                "@media(max-width:900px)": {
                  width: "100%",
                },
              }}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                Basic Information
              </Typography>
              {getClientDetails?.response?.data?.map((item) => (
                <Grid2
                  key={item?.clientId}
                  rowGap={2}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "10px",
                  }}
                >
                  <Grid2
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ width: "50%" }}>
                      <InputLabel sx={{ color: "#535862", fontSize: "14px" }}>
                        Display Name
                      </InputLabel>
                      <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                        {item?.displayName || "-"}
                      </Typography>
                    </Box>
                    <Box sx={{ width: "40%", marginLeft: "10px" }}>
                      <InputLabel sx={{ color: "#535862" }}>
                        Alternate Number
                      </InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.alternateNumber || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.alternateNumber || "-"}
                        </Typography>
                      )}
                    </Box>
                  </Grid2>

                  <Grid2
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ width: "50%" }}>
                      <InputLabel sx={{ color: "#535862" }}>
                        Contact Number
                      </InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.clientPhone || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.clientPhone || "-"}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: "40%", marginLeft: "10px" }}>
                      <InputLabel sx={{ color: "#535862" }}>
                        Alternate Email
                      </InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.alternateEmail || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.alternateEmail || "-"}
                        </Typography>
                      )}
                    </Box>
                  </Grid2>

                  <Grid2
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ width: "50%" }}>
                      <InputLabel sx={{ color: "#535862" }}>Email</InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.clientEmail || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.clientEmail || "-"}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: "40%", marginLeft: "10px" }}>
                      <InputLabel sx={{ color: "#535862" }}>Website</InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.websiteName || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.websiteName || "-"}
                        </Typography>
                      )}
                    </Box>
                  </Grid2>

                  <Grid2
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ width: "50%" }}>
                      <InputLabel sx={{ color: "#535862" }}>Address</InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.clientAddress || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.clientAddress || "-"}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: "40%", marginLeft: "10px" }}>
                      <InputLabel sx={{ color: "#535862" }}>Status</InputLabel>
                      <Typography
                        className={`viewClientStatus-badge ${item?.clientStatusName?.toLowerCase()}`}
                      >
                        {item?.clientStatusName || "-"}
                      </Typography>
                    </Box>
                  </Grid2>

                  <Grid2
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ width: "50%" }}>
                      <InputLabel sx={{ color: "#535862" }}>
                        Agreement Start Date
                      </InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.agreementStartDate || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.agreementStartDate || "-"}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: "40%", marginLeft: "10px" }}>
                      <InputLabel sx={{ color: "#535862" }}>
                        Agreement End Date
                      </InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography sx={{ fontSize: "14px" }}>
                            {item?.agreementEndDate || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ fontSize: "14px" }}>
                          {item?.agreementEndDate || "-"}
                        </Typography>
                      )}
                    </Box>
                  </Grid2>
                  {item?.isReferral === "N" ? (
                    <></>
                  ) : (
                    <Grid2
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ width: "50%" }}>
                        <InputLabel sx={{ color: "#535862" }}>
                          Client Commission Type
                        </InputLabel>
                        {userRole === "recruiter" ? (
                          item?.clientCreatedBy === "You" &&
                            item?.isReferral === "Y" ? (
                            <Typography
                              sx={{ color: "#414651", fontSize: "14px" }}
                            >
                              {item?.clientRewardType === "FC"
                                ? "Fixed Amount"
                                : item?.clientRewardType === "FP"
                                  ? "Fixed Percentage"
                                  : "-" || "-"}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ color: "#414651", fontSize: "14px" }}
                            >
                              ******
                            </Typography>
                          )
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.clientRewardType === "FC"
                              ? "Fixed Amount"
                              : item?.clientRewardType === "FP"
                                ? "Fixed Percentage"
                                : "-" || "-"}
                          </Typography>
                        )}
                      </Box>
                      <Box sx={{ width: "40%", marginLeft: "10px" }}>
                        <InputLabel sx={{ color: "#535862" }}>
                          Commission{" "}
                          {item?.clientRewardType === "FC"
                            ? "(Rs)"
                            : item?.clientRewardType === "FP"
                              ? "(%)"
                              : ""}{" "}
                        </InputLabel>
                        {userRole === "recruiter" ? (
                          item?.clientCreatedBy === "You" &&
                            item?.isReferral === "Y" ? (
                            <Typography sx={{ fontSize: "14px" }}>
                              {item?.clientRewardType === "FC"
                                ? "Rs." + item?.clientRewardAmount || "-"
                                : item?.clientRewardPct
                                  ? item?.clientRewardPct + "(%)"
                                  : "" || "-"}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ color: "#414651", fontSize: "14px" }}
                            >
                              ******
                            </Typography>
                          )
                        ) : (
                          <Typography sx={{ fontSize: "14px" }}>
                            {item?.clientRewardType === "FC"
                              ? "Rs." + item?.clientRewardAmount || "-"
                              : item?.clientRewardPct
                                ? item?.clientRewardPct + "(%)"
                                : "" || "-"}
                          </Typography>
                        )}
                      </Box>
                    </Grid2>
                  )}

                  {item?.isReferral === "N" ? (
                    <></>
                  ) : (
                    <Grid2
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ width: "50%" }}>
                        <InputLabel sx={{ color: "#535862" }}>
                          Client Contract Commission Type
                        </InputLabel>
                        {userRole === "recruiter" ? (
                          item?.clientCreatedBy === "You" &&
                            item?.isReferral === "Y" ? (
                            <Typography
                              sx={{ color: "#414651", fontSize: "14px" }}
                            >
                              {item?.contractRewardType === "FC"
                                ? "Fixed Amount"
                                : item?.contractRewardType === "FP"
                                  ? "Fixed Percentage"
                                  : "-" || "-"}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ color: "#414651", fontSize: "14px" }}
                            >
                              ******
                            </Typography>
                          )
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.contractRewardType === "FC"
                              ? "Fixed Amount"
                              : item?.contractRewardType === "FP"
                                ? "Fixed Percentage"
                                : "-" || "-"}
                          </Typography>
                        )}
                      </Box>
                      <Box sx={{ width: "40%", marginLeft: "10px" }}>
                        <InputLabel sx={{ color: "#535862" }}>
                          Commission{" "}
                          {item?.contractRewardType === "FC"
                            ? "(Rs)"
                            : item?.contractRewardType === "FP"
                              ? "(%)"
                              : ""}{" "}
                        </InputLabel>
                        {userRole === "recruiter" ? (
                          item?.clientCreatedBy === "You" &&
                            item?.isReferral === "Y" ? (
                            <Typography sx={{ fontSize: "14px" }}>
                              {item?.contractRewardType === "FC"
                                ? "Rs." + item?.contractRewardAmount || "-"
                                : item?.contractRewardPct
                                  ? item?.contractRewardPct + "(%)"
                                  : "" || "-"}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ color: "#414651", fontSize: "14px" }}
                            >
                              ******
                            </Typography>
                          )
                        ) : (
                          <Typography sx={{ fontSize: "14px" }}>
                            {item?.contractRewardType === "FC"
                              ? "Rs." + item?.contractRewardAmount || "-"
                              : item?.contractRewardPct
                                ? item?.contractRewardPct + "(%)"
                                : "" || "-"}
                          </Typography>
                        )}
                      </Box>
                    </Grid2>
                  )}

                  <Grid2
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <InputLabel sx={{ color: "#535862" }}>
                        Reason for Rejection
                      </InputLabel>
                      {userRole === "recruiter" ? (
                        item?.clientCreatedBy === "You" ? (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            {item?.feedBack || "-"}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{ color: "#414651", fontSize: "14px" }}
                          >
                            ******
                          </Typography>
                        )
                      ) : (
                        <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                          {item?.feedBack || "-"}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: "40%", marginLeft: "10px" }}>
                      <InputLabel sx={{ color: "#535862" }}>
                        Created Date
                      </InputLabel>
                      <Typography sx={{ fontSize: "14px" }}>
                        {dayjs(createdDate).format("YYYY-MM-DD")}
                      </Typography>
                    </Box>
                  </Grid2>

                  {
                    userRole === "admin" && (
                      <Grid2
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box>
                          <InputLabel sx={{ color: "#535862" }}>
                            Client Sourced by
                          </InputLabel>
                          <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                            {item?.submittedBy || "-"}
                          </Typography>
                        </Box>
                      </Grid2>
                    )
                  }

                </Grid2>
              ))}
            </Box>

            {userRole === "recruiter" ? (
              clientCreatedBy === "You" ? (
                <Box sx={{ width: "100%" }}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    Client Contacts
                  </Typography>

                  {clientContactTableDatas.length <= 0 ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "left",
                        justifyContent: "left",
                        marginTop: "10px",
                      }}
                    >
                      <Typography sx={{ color: "#535862" }}>
                        {" "}
                        No client contacts
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        marginTop: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {clientContactTableDatas?.map((client) => (
                        <Box
                          key={client?.clientId}
                          sx={{
                            border: "1px solid #E9EAEB",
                            padding: 2,
                            borderRadius: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{ fontWeight: 600, fontSize: 14 }}
                              >
                                {client?.clientName}
                              </Typography>
                              <InputLabel
                                sx={{ color: "#717680", fontSize: 14 }}
                              >
                                {client?.designation}
                              </InputLabel>
                            </Box>
                            {client?.location !== "" && (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <LocationOnIcon className="icons" />
                                </Typography>
                                <Typography
                                  sx={{ color: "#535862", fontSize: 14 }}
                                >
                                  {client?.location || "--"}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                marginTop: "15px",
                              }}
                            >
                              <Grid2>
                                <Typography variant="body3">
                                  <Box
                                    sx={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      color: "#6941C6",
                                      fontWeight: 550,
                                      cursor: "pointer",
                                      fontSize: 14,
                                    }}
                                    onClick={handleClientEdit}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <EmailOutlinedIcon className="icons" />
                                    </Typography>
                                    {client?.email}
                                    <NorthEastIcon
                                      sx={{ fontSize: 20, marginLeft: "4px" }}
                                    />
                                  </Box>
                                </Typography>
                              </Grid2>
                              {client?.alternateEmail !== "" && (
                                <Grid2
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <AlternateEmailOutlinedIcon className="icons" />
                                  </Typography>
                                  <Typography
                                    sx={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      color: "#535862",
                                      cursor: "pointer",
                                      fontSize: 14,
                                    }}
                                  >
                                    {client?.alternateEmail || "--"}
                                  </Typography>
                                </Grid2>
                              )}
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                marginTop: "15px",
                              }}
                            >
                              <Grid2>
                                <Typography variant="body3">
                                  <Box
                                    sx={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      color: "#6941C6",
                                      fontWeight: 550,
                                      cursor: "pointer",
                                      fontSize: 14,
                                    }}
                                    onClick={handleClientEdit}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <LocalPhoneOutlinedIcon className="icons" />
                                    </Typography>
                                    {client?.contactNumber}
                                    <NorthEastIcon
                                      sx={{ fontSize: 20, marginLeft: "4px" }}
                                    />
                                  </Box>
                                </Typography>
                              </Grid2>
                              {client?.alternateNumber !== "" && (
                                <Grid2
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography variant="body3">
                                    <Box
                                      sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        color: "#535862",
                                        cursor: "pointer",
                                        fontSize: 14,
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <AddIcCallOutlinedIcon className="icons" />
                                      </Typography>
                                      {client?.alternateNumber || "-"}
                                    </Box>
                                  </Typography>
                                </Grid2>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              ) : (
                <></>
              )
            ) : (
              <Box sx={{ width: "100%" }}>
                <Typography sx={{ fontWeight: "bold" }}>
                  Client Contacts
                </Typography>

                {clientContactTableDatas.length <= 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "left",
                      justifyContent: "left",
                      marginTop: "10px",
                    }}
                  >
                    <Typography sx={{ color: "#535862" }}>
                      {" "}
                      No client contacts
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      marginTop: "10px",
                      flexWrap: "wrap",
                    }}
                  >
                    {clientContactTableDatas?.map((client) => (
                      <Box
                        key={client?.clientId}
                        sx={{
                          border: "1px solid #E9EAEB",
                          padding: 2,
                          borderRadius: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>
                            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                              {client?.clientName}
                            </Typography>
                            <InputLabel sx={{ color: "#717680", fontSize: 14 }}>
                              {client?.designation}
                            </InputLabel>
                          </Box>
                          {client?.location !== "" && (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <LocationOnIcon className="icons" />
                              </Typography>
                              <Typography
                                sx={{ color: "#535862", fontSize: 14 }}
                              >
                                {client?.location || "--"}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              marginTop: "15px",
                            }}
                          >
                            <Grid2>
                              <Typography variant="body3">
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    color: "#6941C6",
                                    fontWeight: 550,
                                    cursor: "pointer",
                                    fontSize: 14,
                                  }}
                                  onClick={handleClientEdit}
                                >
                                  <Typography
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <EmailOutlinedIcon className="icons" />
                                  </Typography>
                                  {client?.email}
                                  <NorthEastIcon
                                    sx={{ fontSize: 20, marginLeft: "4px" }}
                                  />
                                </Box>
                              </Typography>
                            </Grid2>
                            {client?.alternateEmail !== "" && (
                              <Grid2
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <AlternateEmailOutlinedIcon className="icons" />
                                </Typography>
                                <Typography
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    color: "#535862",
                                    cursor: "pointer",
                                    fontSize: 14,
                                  }}
                                >
                                  {client?.alternateEmail || "--"}
                                </Typography>
                              </Grid2>
                            )}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              marginTop: "15px",
                            }}
                          >
                            <Grid2>
                              <Typography variant="body3">
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    color: "#6941C6",
                                    fontWeight: 550,
                                    cursor: "pointer",
                                    fontSize: 14,
                                  }}
                                  onClick={handleClientEdit}
                                >
                                  <Typography
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <LocalPhoneOutlinedIcon className="icons" />
                                  </Typography>
                                  {client?.contactNumber}
                                  <NorthEastIcon
                                    sx={{ fontSize: 20, marginLeft: "4px" }}
                                  />
                                </Box>
                              </Typography>
                            </Grid2>
                            {client?.alternateNumber !== "" && (
                              <Grid2
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography variant="body3">
                                  <Box
                                    sx={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      color: "#535862",
                                      cursor: "pointer",
                                      fontSize: 14,
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <AddIcCallOutlinedIcon className="icons" />
                                    </Typography>
                                    {client?.alternateNumber || "-"}
                                  </Box>
                                </Typography>
                              </Grid2>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </TabPanel>

        <TabPanel value="2" sx={{ display: "flex", padding: "0px" }}>
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
              border: "1px solid #E9EAEB",
            }}
            elevation={0}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="tableHeadersCell">
                    {" "}
                    Client Name{" "}
                  </TableCell>
                  <TableCell className="tableHeadersCell">
                    {" "}
                    Position Name{" "}
                  </TableCell>
                  <TableCell className="tableHeadersCell">
                    Position Type
                  </TableCell>
                  <TableCell className="tableHeadersCell">
                    Fulfill Status
                  </TableCell>
                  <TableCell className="tableHeadersCell">
                    Job location
                  </TableCell>
                  <TableCell className="tableHeadersCell">
                    {" "}
                    Referred By{" "}
                  </TableCell>
                  <TableCell className="tableHeadersCell">Status</TableCell>
                </TableRow>
              </TableHead>

              {!showTableLoader ? (
                jobDetails?.length > 0 ? (
                  <TableBody>
                    {jobDetails?.map((item, index) => {
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#53389E", fontWeight: 600 }}
                          >
                            {item.clientName}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#535862" }}
                          >
                            {item.positionTitle}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ Color: "#181D27" }}
                          >
                            {item.positionType}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ Color: "#181D27" }}
                          >
                            <Avatar
                              sx={{
                                bgcolor: "transparent",
                                fontWeight: "bold",
                                bgcolor: "#9C7BAF",
                                // background: 'linear-gradient(to bottom, rgb(126, 103, 123), rgb(180, 148, 164))',
                                // backgroundColor:'rgb(175, 60, 164)',
                                color: "white",
                                border: "1px solid white",
                                width: 40,
                                height: 40,
                                fontSize: "14px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {item.joinedCount + "/" + item.noOfPosition}
                            </Avatar>
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            {item.jobLocation}
                          </TableCell>
                          <TableCell
                            className="tableBodyCells"
                            sx={{ color: "#181D27" }}
                          >
                            {item.createdByPosition}
                          </TableCell>
                          <TableCell className="tableBodyCells">
                            {" "}
                            <span
                              className={`viewClientStatus-badge ${item?.status?.toLowerCase()}`}
                            >
                              {item.status}
                            </span>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Typography className="emptydatas">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                <TableRow>
                  <TableCell colSpan={100}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <MUICancelButton
                        title="Previous"
                        startIcon={
                          <ArrowBackIcon
                            sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                          />
                        }
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 1}
                        sx={{ height: "36px" }}
                      />

                      <Pagination
                        page={page}
                        onChange={handleChangePage}
                        count={Math.ceil(totalDataCount / rowsPerPage)}
                        siblingCount={1}
                        boundaryCount={1}
                        shape="rounded"
                        hideNextButton
                        hidePrevButton
                      />

                      <MUICancelButton
                        title="Next"
                        startIcon={
                          <ArrowForwardIcon
                            sx={{
                              color:
                                page === Math.ceil(totalDataCount / rowsPerPage)
                                  ? "#a2a2a2"
                                  : "#414651",
                            }}
                          />
                        }
                        onClick={() => handleChangePage(null, page + 1)}
                        disabled={
                          page === Math.ceil(totalDataCount / rowsPerPage)
                        }
                        sx={{ height: "36px" }}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </Paper>
        </TabPanel>

        <TabPanel value="3" sx={{ padding: "0px" }}>
          <Box>
            {showTableLoader ? (
              <SimpleCommissionLoader />
            ) : (
              <Box>
                {companyCommissionList?.response?.data?.length > 0 ? (
                  // Table component
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      gap: "5px",
                      mt: "5px"
                    }}
                  >
                    <Typography className="title">Company Commission</Typography>
                    <TableContainer
                      component={Paper}
                      elevation={4}
                      sx={{
                        borderRadius: 4,
                        overflow: "hidden",
                        border: "1px solid #d1c8e3ff",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                        },
                      }}
                    >
                      <Table sx={{ minWidth: 650 }} aria-label="commission table">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#f7f6faff" }}>
                            <TableCell sx={{ fontWeight: 700, color: "#004d40", fontSize: '14px', py: 2 }}>
                              Position Level
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#004d40", fontSize: '14px', py: 2 }}>
                              Commission Type
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#004d40", fontSize: '14px', py: 2 }}>
                              Percentage
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#004d40", fontSize: '14px', py: 2 }}>
                              Amount
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#004d40", fontSize: '14px', py: 2 }}>
                              Status
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#004d40", fontSize: '14px', py: 2 }}>
                              Created Date
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#004d40", fontSize: '14px', py: 2, textAlign: 'center' }}>
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {companyCommissionList?.response?.data?.map((item, index) => (
                            <motion.tr
                              key={item.id}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{
                                type: "spring",
                                stiffness: 120,
                                damping: 10,
                                delay: index * 0.1,
                              }}
                            >
                              <TableCell
                                sx={{
                                  color: "#37474f",
                                  borderBottom: "1px solid #e0f2f1",
                                  py: 2
                                }}
                              >
                                {item.jobPositionLevelName}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#37474f",
                                  borderBottom: "1px solid #e0f2f1",
                                  py: 2
                                }}
                              >
                                {item.companyCommissionType === "FC" ? "Fixed Amount" : "Fixed Percentage"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#37474f",
                                  borderBottom: "1px solid #e0f2f1",
                                  py: 2
                                }}
                              >
                                {item.companyCommissionType === "FP"
                                  ? `${item.companyCommissionPercentage ?? "-"}%`
                                  : "-"
                                }
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#37474f",
                                  borderBottom: "1px solid #e0f2f1",
                                  py: 2
                                }}
                              >
                                {item.companyCommissionType === "FC"
                                  ? `₹${item.companyCommissionAmount ?? "-"}`
                                  : "-"
                                }
                              </TableCell>
                              <TableCell sx={{ borderBottom: "1px solid #e0f2f1", py: 2 }}>
                                <Box
                                  // sx={{
                                  //   fontSize: "0.8rem",
                                  //   px: 1.5,
                                  //   py: 0.5,
                                  //   borderRadius: "10px",
                                  //   // color: item.status === "Active" ? "#1b5e20" : "#b71c1c",
                                  //   backgroundColor: item.status === "Active" ? "#c8e6c9" : "#ffcdd2",
                                  //   fontWeight: 600,
                                  //   textAlign: "center",
                                  //   display: "inline-block",
                                  //   width: "fit-content",
                                  // }}
                                  className={`viewClientStatus-badge ${item?.status?.toLowerCase()}`}
                                >
                                  {item.status}
                                </Box>
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#607d8b",
                                  fontStyle: "italic",
                                  borderBottom: "1px solid #e0f2f1",
                                  py: 2
                                }}
                              >
                                {dayjs(item.createdDate).format('DD-MM-YYYY')}
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: "1px solid #e0f2f1",
                                  py: 2
                                }}
                              >
                                <Box sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  gap: 2
                                }}>
                                  <CiEdit
                                    style={{
                                      color: "#1976d2",
                                      fontSize: "20px",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease"
                                    }}
                                    onClick={() => handleOpenCommissionEdit(item)}
                                    onMouseEnter={(e) => e.target.style.transform = "scale(1.2)"}
                                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                                  />
                                  <Switch
                                    checked={item.status === "Active"}
                                    onChange={() => handleToggleStatus(item)}
                                    size="small"
                                    sx={{
                                      '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: "#2e7d32",
                                      },
                                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: "#4caf50",
                                      },
                                    }}
                                  />
                                </Box>
                              </TableCell>
                            </motion.tr>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                ) : companyCommissionList ? (
                  // No commission UI
                  <>
                    <style>{`
            @keyframes haloPulse {
              0% { transform: scale(0.9); opacity: 0.18; }
              50% { transform: scale(1.06); opacity: 0.28; }
              100% { transform: scale(0.9); opacity: 0.18; }
            }
            @keyframes floatUp {
              0% { transform: translateY(6px); }
              50% { transform: translateY(-6px); }
              100% { transform: translateY(6px); }
            }
          `}</style>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "60vh",
                        p: 3,
                      }}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          width: { xs: "85%", sm: 680 },
                          maxWidth: "100%",
                          textAlign: "center",
                        }}
                      >
                        <Box
                          aria-hidden
                          sx={{
                            position: "absolute",
                            left: "50%",
                            top: "8%",
                            transform: "translateX(-50%)",
                            width: 260,
                            height: 260,
                            borderRadius: "50%",
                            background: "radial-gradient(circle at 30% 30%, rgba(72,187,153,0.18), rgba(72,187,153,0.06) 40%, rgba(255,255,255,0) 70%)",
                            filter: "blur(18px)",
                            zIndex: 0,
                            animation: "haloPulse 3.6s ease-in-out infinite",
                          }}
                        />
                        <Box
                          sx={{
                            position: "relative",
                            zIndex: 2,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 96,
                            height: 96,
                            borderRadius: "22px",
                            margin: "0 auto 18px",
                            background: "linear-gradient(180deg, rgba(255,255,255,0.9), rgba(250,250,250,0.75))",
                            border: "1px solid rgba(0,0,0,0.06)",
                            boxShadow: "0 8px 22px rgba(20,40,60,0.08)",
                            animation: "floatUp 4.5s ease-in-out infinite",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 0.5,
                            }}
                          >
                            <MonetizationOnIcon sx={{ fontSize: 36, color: "#7F56D9" }} />
                          </Box>
                        </Box>
                        <Box>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              mb: 1,
                              color: "#184d47", /* calm teal */
                            }}
                          >
                            No commission amount added yet
                          </Typography>

                          <Button
                            startIcon={<AddIcon />}
                            sx={{
                              textTransform: "none",
                              fontWeight: 700,
                              borderRadius: "12px",
                              px: 3.5,
                              py: 1.1,
                              boxShadow: "0 6px 18px rgba(46,125,50,0.14)",
                              background: "#7F56D9",
                              color: "#fff",
                              "&:hover": {
                                transform: "translateY(-2px)",
                                boxShadow: "0 10px 26px rgba(46,125,50,0.18)",
                              },
                            }}
                            variant="contained"
                            onClick={handleOpenAddCommission}
                          >
                            Add Commission
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </>
                ) : null} {/* Don't render anything while waiting for API response */}
              </Box>
            )}
          </Box>

          <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
              sx: {
                borderRadius: "16px",
                width: "90%",
                maxWidth: 600,
                background: "linear-gradient(180deg, #ffffff, #f7faff)",
                boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
              },
            }}
          >
            <DialogTitle
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              {!commissionId ? "Add Commission Details" : "Edit Commission Details"}
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              <Box component="form" onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid2 sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Grid2 sx={{ width: '48%' }}>
                    <InputLabel>
                      Client Commission Type <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Controller
                      control={control}
                      name="rewardType"
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          placeholder="Select Reward Type"
                          valueKey="id"
                          labelKey="label"
                          options={rewardTypes || []}
                        />
                      )}
                    />
                    {errors?.rewardType?.message && (
                      <div style={{ color: "red", fontSize: "0.75rem" }}>
                        {errors.rewardType.message}
                      </div>
                    )}
                  </Grid2>
                  <AnimatePresence mode="wait">
                    {isCost && (
                      <Grid2 sx={{ width: '48%' }}>
                        <motion.div
                          key="rewardsRs"
                          initial={{ opacity: 0, y: 15 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -15 }}
                          transition={{ duration: 0.4, ease: "easeOut" }}
                        >
                          <InputLabel>
                            Commission (Rs) <span style={{ color: "red" }}>*</span>
                          </InputLabel>
                          <Controller
                            control={control}
                            name="rewardsRs"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                size="small"
                                className="textfields"
                                type="number"
                                placeholder="Enter Commission (Rs)"
                                onWheel={(e) => e.target.blur()}
                                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                sx={{
                                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                    display: "none",
                                  },
                                }}
                              />
                            )}
                          />
                          {errors?.rewardsRs?.message && (
                            <div style={{ color: "red", fontSize: "0.75rem" }}>
                              {errors.rewardsRs.message}
                            </div>
                          )}
                        </motion.div>
                      </Grid2>
                    )}
                    {!isCost && commissionType && (
                      <Grid2 sx={{ width: '50%' }}>
                        <motion.div
                          key="rewardsPercent"
                          initial={{ opacity: 0, y: 15 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -15 }}
                          transition={{ duration: 0.4, ease: "easeOut" }}
                        >
                          <InputLabel>
                            Commission (%) <span style={{ color: "red" }}>*</span>
                          </InputLabel>
                          <Controller
                            control={control}
                            name="rewardsPercent"
                            render={({ field }) => (
                              <TextField
                                {...field}
                                fullWidth
                                size="small"
                                type="number"
                                className="textfields"
                                placeholder="Enter Commission (%)"
                                onWheel={(e) => e.target.blur()}
                                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                sx={{
                                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                    display: "none",
                                  },
                                }}
                              />
                            )}
                          />
                          {errors?.rewardsPercent?.message && (
                            <div style={{ color: "red", fontSize: "0.75rem" }}>
                              {errors.rewardsPercent.message}
                            </div>
                          )}
                        </motion.div>
                      </Grid2>
                    )}
                    {
                      !commissionType && (
                        <Grid2 sx={{ width: '40%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <motion.div
                            key="selectInfo"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                          >
                            <Typography sx={{ textAlign: 'center', fontSize: '12px', marginTop: '10px' }}>
                              Select a commission type to enter amount or percentage
                            </Typography>
                          </motion.div>
                        </Grid2>
                      )
                    }
                  </AnimatePresence>
                </Grid2>
                <Grid2 sx={{ width: '100%', mt: 2 }}>
                  <InputLabel>
                    Position Level <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Controller
                    name="positionLevel"
                    control={control}
                    render={({ field }) => (
                      <RadioGroup
                        {...field}
                        row
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: 2
                        }}
                      >
                        {positionLevelDropDown?.response?.map((level) => (
                          <FormControlLabel
                            key={level.jobPositionLevelId}
                            value={String(level.jobPositionLevelId)}
                            control={<Radio size="small" />}
                            label={level.jobPositionLevelName}
                          />
                        ))}
                      </RadioGroup>
                    )}
                  />
                  {errors?.positionLevel?.message && (
                    <div style={{ color: "red", fontSize: "0.75rem" }}>
                      {errors.positionLevel.message}
                    </div>
                  )}
                </Grid2>
                <DialogActions sx={{ mt: 4 }}>
                  <MUICancelButton
                    onClick={onClose}
                    title="Cancel"
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      borderRadius: "10px",
                      px: 3,
                      color: "#555",
                    }}
                  >
                    Cancel
                  </MUICancelButton>

                  <MUIButton
                    type="submit"
                    title={commissionId ? "Update" : "Save"}
                    onClick={handleSubmit(saveCompanyCommission)}
                    disabled={isButtonLoading}
                    sx={{
                      position: 'relative',
                      minWidth: 100,
                      '&:disabled': {
                        backgroundColor: '#7F56D9',
                        opacity: 0.8,
                      }
                    }}
                  >
                  </MUIButton>
                </DialogActions>
              </Box>
            </DialogContent>
          </Dialog>
        </TabPanel>
      </TabContext>
    </Box>
  );
};
export default ViewClients;
